<script lang="ts">
    import { _ } from "svelte-i18n"
    import ChevronLeftIcon from "svelte-material-icons/ChevronLeft.svelte"
    import { spaNavigate } from "../../../functionTools/navigation"

    interface Props {
        backlink?: string
        backtitle?: any
        nexttitle?: any
        NextComponent?: any
        submitDisabled?: boolean
        submitHandler?: () => void
    }

    let {
        backlink = "/cart",
        backtitle = $_("checkout.back"),
        nexttitle = $_("checkout.next"),
        NextComponent = null,
        submitDisabled = false,
        submitHandler = null,
    }: Props = $props()
</script>

<div class="checkout_bottom">
    <button
        type="button"
        class="button secondary linkback"
        data-testid="checkout-back"
        onclick={() => {
            spaNavigate(backlink)
        }}>{backtitle}</button
    >
    {#if NextComponent}
        {#if submitDisabled}
            <button type="button" class="button primary" disabled={submitDisabled}>{nexttitle}</button>
        {:else}
            <NextComponent {submitHandler} />
        {/if}
    {:else if nexttitle}
        <button type="submit" class="button primary" data-testid="checkout-submit" disabled={submitDisabled}>{nexttitle}</button>
    {/if}
</div>

<style lang="less">
    button:disabled {
        opacity: 0.1;
    }

    @media (max-width: 800px) {
        .checkout_bottom {
            flex-flow: column;
            gap: 12px;

            .linkback {
                order: 1;
            }
        }
    }
</style>
